module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/mini_serif-italic-web.woff?da05e91721d530b1535404468fa14635";